<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <cinema-map></cinema-map>
      </div>
    </div>
  </div>
</template>

<script>
import CinemaMap from "@/components/CinemaMap";

export default {
  name: 'App',
  components: {
    CinemaMap
  }
}
</script>
